/**
 * @param {Object} props
 * @param {string | undefined} [props.className]
 * @returns {React.ReactElement} The rendered component
 */
const TargetIcon = ({ className }) => (
  <svg
    className={className}
    baseProfile="tiny"
    xmlns="http://www.w3.org/2000/svg"
    width="20px"
    height="20px"
    viewBox="0 0 400 400"
    overflow="visible"
  >
    <g id="Symbols">
      <g
        id="jobsuche_x2F_jobsearch_x2F_FRE_x5F_job_x5F_search_x5F_hero_x5F_XL"
        transform="translate(-1234.000000, -168.000000)"
      >
        <g id="standortsuche" transform="translate(666.000000, 157.000000)">
          <g>
            <path
              fill="currentColor"
              d="M768,130.1c-44.6,0-80.8,36.2-80.8,80.9c0,44.7,36.2,80.9,80.8,80.9c44.6,0,80.8-36.2,80.8-80.9
					C848.8,166.3,812.6,130.1,768,130.1z"
            />
            <path
              fill="currentColor"
              d="M967.7,198.9h-52.3c-5.9-72.1-63.3-129.7-135.3-135.6V11h-24.2v52.3c-72,5.9-129.5,63.5-135.3,135.6h-52.3v24.2h52.3
					c5.9,72.1,63.3,129.7,135.3,135.6V411h24.2v-52.3c72-5.9,129.5-63.5,135.3-135.6h52.3V198.9z M768,332.4
					c-66.8,0-121.1-54.5-121.1-121.4S701.2,89.6,768,89.6c66.8,0,121.1,54.5,121.1,121.4S834.8,332.4,768,332.4z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default TargetIcon;
